export default __webpack_public_path__ + "static/media/2.108e817a.png";